module.exports = __webpack_public_path__ + "assets/img/copy.2bfef85c.png";